<div class="flex column start center w-100 g-24" [style]="containerStyles">
	<h4>{{ 'general.filter_by_period_of_time' | translateWithKeys }}</h4>
	<mat-divider class="w-100"></mat-divider>
	<div class="flex row w-100 space-between g-30">
		<mat-calendar #fromCalendar class="flex w-100" [(selected)]="from" [startAt]="from" [maxDate]="to"></mat-calendar>
		<mat-calendar #toCalendar class="flex w-100" [(selected)]="to" [startAt]="to" [minDate]="from"></mat-calendar>
	</div>
	<div class="flex row w-100 start center g-8">
		<button mat-flat-button class="interval-btn button" (click)="setRange(Interval.WEEK)">{{ 'manage-students.this_week' | translateWithKeys }}</button>
		<button mat-flat-button class="interval-btn button" (click)="setRange(Interval.MONTH)">{{ 'manage-students.this_month' | translateWithKeys }}</button>
		<button mat-flat-button class="interval-btn button" (click)="setRange(Interval.TRIMESTER)">{{ 'manage-students.this_trimester' | translateWithKeys }}</button>
		<button mat-flat-button class="interval-btn button" (click)="setRange(Interval.YEAR)">{{ 'manage-students.this_year' | translateWithKeys }}</button>
	</div>
	<div class="flex row space-between w-100">
		<button mat-stroked-button class="button" (click)="clean()">{{ 'general.clear' | translateWithKeys }}</button>
		<button mat-flat-button class="button bg-primary-darker text-accent-lighter" (click)="applyRange()">{{ 'general.apply' | translateWithKeys }}</button>
	</div>
</div>
